import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmTeams = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	style: { enableBackground: "new 0 0 128 128" },
	viewBox: "0 0 128 128",
	xmlSpace: "preserve",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{fill:#21A365;}\n	.st1{fill:#107C41;}\n	.st2{fill:#185B37;}\n	.st3{fill:#33C481;}\n	.st4{fill:#17864C;}\n	.st5{fill:#FFFFFF;}\n	.st6{fill:#036C70;}\n	.st7{fill:#1A9BA1;}\n	.st8{fill:#37C6D0;}\n	.st9{fill:#04878B;}\n	.st10{fill:#4F59CA;}\n	.st11{fill:#7B82EA;}\n	.st12{fill:#4C53BB;}\n	.st13{fill:#0F78D5;}\n	.st14{fill:#29A7EB;}\n	.st15{fill:#0358A8;}\n	.st16{fill:#0F79D6;}\n	.st17{fill:#038387;}\n	.st18{fill:#048A8E;}\n	.st19{fill:#C8421D;}\n	.st20{fill:#FF8F6A;}\n	.st21{fill:#ED6B47;}\n	.st22{fill:#891323;}\n	.st23{fill:#AF2131;}\n	.st24{fill:#C94E60;}\n	.st25{fill:#E08195;}\n	.st26{fill:#B42839;}\n	.st27{fill:#0464B8;}\n	.st28{fill:#0377D4;}\n	.st29{fill:#4FD8FF;}\n	.st30{fill:#1681D7;}\n	.st31{fill:#0178D4;}\n	.st32{fill:#042071;}\n	.st33{fill:#168FDE;}\n	.st34{fill:#CA64EA;}\n	.st35{fill:#7E1FAF;}\n	.st36{fill:#AE4BD5;}\n	.st37{fill:#9332BF;}\n	.st38{fill:#7719AA;}\n	.st39{fill:#0078D4;}\n	.st40{fill:#1490DF;}\n	.st41{fill:#0364B8;}\n	.st42{fill:#28A8EA;}\n	.st43{fill:#41A5ED;}\n	.st44{fill:#2C7BD5;}\n	.st45{fill:#195ABE;}\n	.st46{fill:#103E91;}\n	.st47{fill:#2166C3;}\n	.st48{opacity:0.2;}\n"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st10",
			cx: 111.1,
			cy: 30.2,
			r: 13
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st10",
			d: "M108.3,104.8h-2c-10.7,0-19.3-8.7-19.3-19.3V54.9c0-3.1,2.5-5.5,5.5-5.5h29.6c3.1,0,5.5,2.5,5.5,5.5v30.5  C127.7,96.1,119,104.8,108.3,104.8z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st11",
			cx: 70.3,
			cy: 24.2,
			r: 18.7
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st11",
			d: "M70.4,122.1h-3.2c-16.8,0-30.5-13.7-30.5-30.5V54.1c0-2.5,2.1-4.6,4.6-4.6h55c2.5,0,4.6,2.1,4.6,4.6v37.5  C100.9,108.4,87.3,122.1,70.4,122.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st12",
			d: "M59.5,97.2h-53c-3.5,0-6.4-2.9-6.4-6.4V38.6c0-3.5,2.9-6.4,6.4-6.4h53c3.5,0,6.4,2.9,6.4,6.4v52.2  C65.9,94.3,63.1,97.2,59.5,97.2z"
		}),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			className: "st5",
			d: "M29.4,52.7H19v-5.5h27.5v5.5H36.1V83h-6.6V52.7z"
		}) }),
		/* @__PURE__ */ _jsx("path", {
			className: "st48",
			d: "M66,49.5v41.2c0,3.5-2.9,6.4-6.4,6.4H37.2l1.5,5.7H65c3.5,0,6.4-2.9,6.4-6.4V49.5L66,49.5z"
		})
	]
});
export default SvgSmTeams;
